import * as brand from './colors';
import { typography } from './typography';
import { shadows } from './shadows';
import { overrides } from './overrides';

export const styles = {
  palette: {
    primary: {
      main: brand.keleGray.main
    },
    secondary: {
      main: brand.keleGreen[500]
    }
  },
  typography,
  shadows,
  overrides
};
